// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdministrationPermissions {
    static _ = 'Administration';

    static User = class {
        static _ = 'Administration.User';

        static ViewAll = 'Administration.User.ViewAll';
        static ViewOwn = 'Administration.User.ViewOwn';
        static Edit = 'Administration.User.Edit';
        static Create = 'Administration.User.Create';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static ViewAll = 'Administration.Role.ViewAll';
        static ViewOwn = 'Administration.Role.ViewOwn';
        static Edit = 'Administration.Role.Edit';
        static Create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static ViewAll = 'Administration.Organization.ViewAll';
        static ViewOwn = 'Administration.Organization.ViewOwn';
        static Edit = 'Administration.Organization.Edit';
        static Create = 'Administration.Organization.Create';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static View = 'Administration.Settings.View';
        static Edit = 'Administration.Settings.Edit';
    };

}

export class CodeListPermissions {
    static _ = 'CodeList';

    static Action = class {
        static _ = 'CodeList.Action';

        static Create = 'CodeList.Action.Create';
        static Delete = 'CodeList.Action.Delete';
        static Edit = 'CodeList.Action.Edit';
        static SyncCustomers = 'CodeList.Action.SyncCustomers';
        static SyncLocations = 'CodeList.Action.SyncLocations';
        static SyncTaxes = 'CodeList.Action.SyncTaxes';
        static SyncServices = 'CodeList.Action.SyncServices';
        static SyncTariffTypes = 'CodeList.Action.SyncTariffTypes';
    };

    static View = class {
        static _ = 'CodeList.View';

        static Item = 'CodeList.View.Item';
        static List = 'CodeList.View.List';
    };

}

export class ContractPermissions {
    static _ = 'Contract';

    static View = class {
        static _ = 'Contract.View';

        static All = 'Contract.View.All';
        static Own = 'Contract.View.Own';
    };

    static Action = class {
        static _ = 'Contract.Action';

        static Create = 'Contract.Action.Create';
        static Edit = 'Contract.Action.Edit';
        static Clone = 'Contract.Action.Clone';
        static Approve = 'Contract.Action.Approve';
        static Expire = 'Contract.Action.Expire';
        static Cancel = 'Contract.Action.Cancel';
        static Terminate = 'Contract.Action.Terminate';
    };

    static Attachments = class {
        static _ = 'Contract.Attachments';

        static View = 'Contract.Attachments.View';
        static Create = 'Contract.Attachments.Create';
        static Edit = 'Contract.Attachments.Edit';
        static Remove = 'Contract.Attachments.Remove';
    };

    static Invoices = class {
        static _ = 'Contract.Invoices';

        static View = 'Contract.Invoices.View';
    };

    static Items = class {
        static _ = 'Contract.Items';

        static Create = 'Contract.Items.Create';
        static Edit = 'Contract.Items.Edit';
        static Remove = 'Contract.Items.Remove';
    };

}

export class CustomerPermissions {
    static _ = 'Customer';

    static View = class {
        static _ = 'Customer.View';

        static All = 'Customer.View.All';
        static Own = 'Customer.View.Own';
    };

    static Action = class {
        static _ = 'Customer.Action';

        static Cancel = 'Customer.Action.Cancel';
        static Create = 'Customer.Action.Create';
        static Edit = 'Customer.Action.Edit';
        static SyncCustomers = 'Customer.Action.SyncCustomers';
    };

}

export class FaqPermissions {
    static _ = 'Faq';

    static Action = class {
        static _ = 'Faq.Action';

        static Save = 'Faq.Action.Save';
        static Delete = 'Faq.Action.Delete';
    };

    static View = class {
        static _ = 'Faq.View';

        static List = 'Faq.View.List';
    };

}

export class InvoicePermissions {
    static _ = 'Invoice';

    static View = class {
        static _ = 'Invoice.View';

        static All = 'Invoice.View.All';
        static Own = 'Invoice.View.Own';
    };

    static Action = class {
        static _ = 'Invoice.Action';

        static Create = 'Invoice.Action.Create';
        static Save = 'Invoice.Action.Save';
        static Discard = 'Invoice.Action.Discard';
        static Close = 'Invoice.Action.Close';
        static ToApproval = 'Invoice.Action.ToApproval';
        static Approve = 'Invoice.Action.Approve';
        static Reject = 'Invoice.Action.Reject';
        static SendToPoint = 'Invoice.Action.SendToPoint';
        static Lock = 'Invoice.Action.Lock';
        static Cancel = 'Invoice.Action.Cancel';
        static FullCreditNote = 'Invoice.Action.FullCreditNote';
        static CreateItem = 'Invoice.Action.CreateItem';
        static Amend = 'Invoice.Action.Amend';
        static SyncInvoiceStatus = 'Invoice.Action.SyncInvoiceStatus';
    };

    static Attachments = class {
        static _ = 'Invoice.Attachments';

        static View = 'Invoice.Attachments.View';
        static Create = 'Invoice.Attachments.Create';
        static Edit = 'Invoice.Attachments.Edit';
        static Remove = 'Invoice.Attachments.Remove';
    };

    static Items = class {
        static _ = 'Invoice.Items';

        static Create = 'Invoice.Items.Create';
        static Edit = 'Invoice.Items.Edit';
        static Remove = 'Invoice.Items.Remove';
    };

}

export class NoticeBoardPermissions {
    static _ = 'NoticeBoard';

    static Action = class {
        static _ = 'NoticeBoard.Action';

        static Create = 'NoticeBoard.Action.Create';
        static Edit = 'NoticeBoard.Action.Edit';
    };

    static View = class {
        static _ = 'NoticeBoard.View';

        static Deactivated = 'NoticeBoard.View.Deactivated';
        static List = 'NoticeBoard.View.List';
    };

}

export class PricelistPermissions {
    static _ = 'Pricelist';

    static View = class {
        static _ = 'Pricelist.View';

        static All = 'Pricelist.View.All';
        static Own = 'Pricelist.View.Own';
    };

    static Action = class {
        static _ = 'Pricelist.Action';

        static Cancel = 'Pricelist.Action.Cancel';
        static Create = 'Pricelist.Action.Create';
        static Edit = 'Pricelist.Action.Edit';
    };

    static Items = class {
        static _ = 'Pricelist.Items';

        static Create = 'Pricelist.Items.Create';
        static Edit = 'Pricelist.Items.Edit';
        static Remove = 'Pricelist.Items.Remove';
    };

}

export class ReportingPermissions {
    static _ = 'Reporting';

    static View = class {
        static _ = 'Reporting.View';

        static List = 'Reporting.View.List';
    };

}

export class TicketPermissions {
    static _ = 'Ticket';

    static View = class {
        static _ = 'Ticket.View';

        static All = 'Ticket.View.All';
        static Own = 'Ticket.View.Own';
    };

    static Action = class {
        static _ = 'Ticket.Action';

        static Cancel = 'Ticket.Action.Cancel';
        static Edit = 'Ticket.Action.Edit';
        static Bill = 'Ticket.Action.Bill';
        static Debug = 'Ticket.Action.Debug';
    };

}

export class UtilitiesConsumptionPermissions {
    static _ = 'UtilitiesConsumption';

    static View = class {
        static _ = 'UtilitiesConsumption.View';

        static All = 'UtilitiesConsumption.View.All';
        static Power = 'UtilitiesConsumption.View.Power';
        static Water = 'UtilitiesConsumption.View.Water';
        static Own = 'UtilitiesConsumption.View.Own';
    };

    static Action = class {
        static _ = 'UtilitiesConsumption.Action';

        static Cancel = 'UtilitiesConsumption.Action.Cancel';
        static Create = 'UtilitiesConsumption.Action.Create';
        static Edit = 'UtilitiesConsumption.Action.Edit';
        static Delete = 'UtilitiesConsumption.Action.Delete';
        static GetPowerConsumptions = 'UtilitiesConsumption.Action.GetPowerConsumptions';
    };

    static Invoices = class {
        static _ = 'UtilitiesConsumption.Invoices';

        static View = 'UtilitiesConsumption.Invoices.View';
    };

}

export class UtilitiesPriceCalculationPermissions {
    static _ = 'UtilitiesPriceCalculation';

    static View = class {
        static _ = 'UtilitiesPriceCalculation.View';

        static All = 'UtilitiesPriceCalculation.View.All';
        static Own = 'UtilitiesPriceCalculation.View.Own';
    };

    static Action = class {
        static _ = 'UtilitiesPriceCalculation.Action';

        static Cancel = 'UtilitiesPriceCalculation.Action.Cancel';
        static Create = 'UtilitiesPriceCalculation.Action.Create';
        static Edit = 'UtilitiesPriceCalculation.Action.Edit';
    };

}

export class VesselPermissions {
    static _ = 'Vessel';

    static View = class {
        static _ = 'Vessel.View';

        static All = 'Vessel.View.All';
        static Own = 'Vessel.View.Own';
    };

    static Action = class {
        static _ = 'Vessel.Action';

        static Cancel = 'Vessel.Action.Cancel';
        static Create = 'Vessel.Action.Create';
        static Edit = 'Vessel.Action.Edit';
    };

}

export class VesselVisitPermissions {
    static _ = 'VesselVisit';

    static View = class {
        static _ = 'VesselVisit.View';

        static All = 'VesselVisit.View.All';
        static Own = 'VesselVisit.View.Own';
    };

    static Action = class {
        static _ = 'VesselVisit.Action';

        static Cancel = 'VesselVisit.Action.Cancel';
        static Create = 'VesselVisit.Action.Create';
        static Edit = 'VesselVisit.Action.Edit';
        static InsertAta = 'VesselVisit.Action.InsertAta';
        static InsertAtd = 'VesselVisit.Action.InsertAtd';
        static InsertManipulationStartDate = 'VesselVisit.Action.InsertManipulationStartDate';
        static InsertManipulationEndDate = 'VesselVisit.Action.InsertManipulationEndDate';
        static NonBillable = 'VesselVisit.Action.NonBillable';
    };

    static Attachments = class {
        static _ = 'VesselVisit.Attachments';

        static Create = 'VesselVisit.Attachments.Create';
        static Edit = 'VesselVisit.Attachments.Edit';
        static Remove = 'VesselVisit.Attachments.Remove';
        static View = 'VesselVisit.Attachments.View';
    };

    static GeneralCargo = class {
        static _ = 'VesselVisit.GeneralCargo';

        static View = 'VesselVisit.GeneralCargo.View';
    };

    static ContainerCargo = class {
        static _ = 'VesselVisit.ContainerCargo';

        static View = 'VesselVisit.ContainerCargo.View';
    };

    static PersonsOnBoard = class {
        static _ = 'VesselVisit.PersonsOnBoard';

        static View = 'VesselVisit.PersonsOnBoard.View';
    };

    static Invoices = class {
        static _ = 'VesselVisit.Invoices';

        static View = 'VesselVisit.Invoices.View';
    };

    static EnergyConsumption = class {
        static _ = 'VesselVisit.EnergyConsumption';

        static View = 'VesselVisit.EnergyConsumption.View';
    };

    static BerthApplications = class {
        static _ = 'VesselVisit.BerthApplications';

        static View = 'VesselVisit.BerthApplications.View';
    };

    static Items = class {
        static _ = 'VesselVisit.Items';

        static Create = 'VesselVisit.Items.Create';
        static Edit = 'VesselVisit.Items.Edit';
        static Remove = 'VesselVisit.Items.Remove';
    };

}


